import { render, staticRenderFns } from "./04.vue?vue&type=template&id=2b3a638b&scoped=true"
import script from "./04.vue?vue&type=script&lang=js"
export * from "./04.vue?vue&type=script&lang=js"
import style0 from "./04.vue?vue&type=style&index=0&id=2b3a638b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a638b",
  null
  
)

export default component.exports